import { useEffect, useState } from 'react'
import { api } from '../api/client'

/**
 * Die Währungen, in die sich umrechnen lässt.
 *
 * AUS DEN DATEN, nicht aus einer Liste im Code: Was nicht in `t_fx_rate`
 * steht, lässt sich nicht umrechnen und soll gar nicht erst wählbar sein.
 * Dasselbe hält `fx_rate_repository.pairs()` schon fest.
 *
 * Die Paare kommen als „EUR/USD" — daraus werden beide Seiten, denn hin und
 * zurück rechnet derselbe Kurs.
 *
 * Steht als Haken hier und nicht dreimal in den Ansichten: Kurse, Kurshistorie
 * und Handelsideen brauchen dieselbe Liste, und eine Ansicht mit einer anderen
 * Auswahl als die Nachbarin wäre ein Rätsel statt einer Hilfe.
 */
export function useWaehrungen(erlaubt: boolean): string[] {
  const [waehrungen, setWaehrungen] = useState<string[]>([])

  useEffect(() => {
    if (!erlaubt) return
    // `aktuell`, weil die Antwort nach dem Abbau eintreffen kann — ein
    // `setState` auf ein abgeräumtes Element ist ein Leck.
    let aktuell = true
    api.fxPairs()
      .then((paare) => {
        if (!aktuell) return
        setWaehrungen([...new Set(paare.flatMap((p) => p.split('/')))].sort())
      })
      .catch(() => { /* Ohne Paare bleibt die Auswahl eben leer. */ })
    return () => { aktuell = false }
  }, [erlaubt])

  return waehrungen
}
